import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

/**
 * Shared fuzzy / exact law firm match confirmation dialog (bond wizard, admin, register).
 */
/** Wires wizard/admin fuzzy-match state into {@link LawFirmFuzzyMatchDialog}. */
export function LawFirmFuzzyMatchDialogBound({
  open,
  setOpen,
  fuzzyMatchResult,
  setFuzzyMatchResult,
  onUseExisting,
  onCreateAnyway,
  ...rest
}) {
  const handleClose = () => {
    setOpen(false);
    setFuzzyMatchResult(null);
  };
  return (
    <LawFirmFuzzyMatchDialog
      open={open}
      onClose={handleClose}
      firmName={fuzzyMatchResult?.name}
      exactMatch={fuzzyMatchResult?.exactMatch}
      onUseExisting={onUseExisting}
      onCreateAnyway={fuzzyMatchResult?.exactMatch ? undefined : onCreateAnyway}
      {...rest}
    />
  );
}

export default function LawFirmFuzzyMatchDialog({
  open,
  onClose,
  firmName,
  exactMatch = false,
  onUseExisting,
  onCreateAnyway,
  showCancel = false,
  useExistingLabel = "Use existing",
  createAnywayLabel = "Create new anyway",
  titleExact = "Law firm already exists",
  titleSimilar = "Similar law firm found",
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{exactMatch ? titleExact : titleSimilar}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {exactMatch ? (
            <>
              A law firm with this name already exists: <strong>{firmName ?? "—"}</strong>. Select
              it to continue.
            </>
          ) : (
            <>
              A similar law firm was found: <strong>{firmName ?? "—"}</strong>. Do you want to use
              this existing firm or create a new one?
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        {showCancel && onClose && (
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
        )}
        {!exactMatch && onCreateAnyway && (
          <Button onClick={onCreateAnyway} color="secondary">
            {createAnywayLabel}
          </Button>
        )}
        <Button onClick={onUseExisting} color="primary" variant="contained">
          {useExistingLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
